import { FilterOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { DataViewProps } from './DataView';

export const SimpleTextFilter = function (
    props: DataViewProps<string>
) {

    const onChange = (ev: any) => {
        props.setData(ev.target.value);
    }

    return (
        <Input className='search' placeholder="Filter" prefix={<FilterOutlined />} onChange={onChange} />
    );

};